import _ from "lodash";
import { db, docFromSnapshot } from "../firebase";
import { dateToHumanWithTime } from "@/helpers/helpers";
import moment from "moment";

export const DEFAULT_DASHBOARD_STATISTICS = {
  invoicesByDay: {},
  paidByday: {},
  totalInvoiced: 0,
  totalPaid: 0,
  totalItemsSold: 0,
  events: []
};

const state = {
  dashboardStatistics: DEFAULT_DASHBOARD_STATISTICS
};

function getTotalsForPreviousDays(state, daysFromToday, numDays) {
  const daysFromTodayOffset = daysFromToday + numDays - 1;
  const days = [...new Array(numDays)].map((i, idx) =>
    moment()
      .startOf("day")
      .subtract(daysFromTodayOffset - idx, "days")
  );

  const totalInvoicedByDay = _.get(
    state,
    "dashboardStatistics.totalInvoicedByDay",
    {}
  );
  const totalPaidByDay = _.get(state, "dashboardStatistics.totalPaidByDay", {});

  return days.reduce(
    (totals, day) => {
      totals.labels.push(day.format("D/M/YY"));

      const dayKey = day.format("YYYYMMDD");

      totals.invoiced.push(_.get(totalInvoicedByDay, dayKey, 0));
      totals.paid.push(_.get(totalPaidByDay, dayKey, 0));

      return totals;
    },
    { labels: [], invoiced: [], paid: [] }
  );
}

const getters = {
  dashboardTotalsCurrent30DayBlock: state =>
    getTotalsForPreviousDays(state, 0, 30),
  dashboardTotalsPrevious30DayBlock: state =>
    getTotalsForPreviousDays(state, 30, 30),
  dashboardTotalInvoiced: state =>
    _.get(state, "dashboardStatistics.totalInvoiced", 0),
  dashboardTotalPaid: state => _.get(state, "dashboardStatistics.totalPaid", 0),
  dashboardBalance: state =>
    _.get(state, "dashboardStatistics.totalInvoiced", 0) -
    _.get(state, "dashboardStatistics.totalPaid", 0),
  dashboardItemsSold: state =>
    _.get(state, "dashboardStatistics.totalItemsSold", 0),
  dashboardEvents: state =>
    _.get(state, "dashboardStatistics.events", []).map(event => {
      event.dateAndTime = dateToHumanWithTime(event.timestamp);
      return event;
    })
};

const actions = {
  async fetchDashboardStatistics(context) {
    const snapshot = await db
      .collection("dashboard-statistics")
      .doc(context.getters.tenantId)
      .get();

    context.commit("setDashboardStatistics", docFromSnapshot(snapshot));
  }
};

const mutations = {
  setDashboardStatistics(state, payload) {
    state.dashboardStatistics = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
